<template>
  <div>
    <div class="field">
      <label class="label">
        {{ response.questionRef.questionText }}
        <i class="fa fa-refresh fa-spin" v-if="response.isLoading" style="padding: 0 4px"></i>
      </label>
      {{ response.questionRef.helpText }}
      <div class="control" v-if="response.questionRef.questionType === 'SCALE'">
        <div class="control">
          <label
            class="radio"
            v-for="(choice, index) in response.questionRef.choices"
            :for="`${response.id} ${index}`"
            style="padding: 4px"
            :key="index"
          >
            <input
              class="radio"
              type="radio"
              :id="`${response.id} ${index}`"
              :value="choice"
              v-model="response.response"
              @change="signalChange(response)"
            />
            <span style="padding: 4px">{{ choice }}</span>
          </label>
        </div>
        <!-- <div class="select">
          <select v-model="response.response">
            <option :value="null">Select from below</option>
            <option v-for="(choice, index) in response.questionRef.choices" :key="index">
              {{ choice }}
            </option>
          </select>
        </div> -->
      </div>
      <div class="control" v-if="response.questionRef.questionType === 'MC'">
        <div class="select">
          <select v-model="response.response" @change="signalChange(response)">
            <option :value="null">Select from below</option>
            <option v-for="(choice, index) in response.questionRef.choices" :key="index">
              {{ choice }}
            </option>
          </select>
        </div>
      </div>
      <div class="control" v-if="response.questionRef.questionType === 'OPEN_TEXT'">
        <textarea
          :class="isNA ? 'textarea skipped' : 'textarea'"
          v-model="response.response"
          @change="signalChange(response)"
        ></textarea>
        <button v-if="!response.response || response.response.length < 10" @click="toggleNA">
          {{ isNA ? 'unskip' : 'skip' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// TODO: This is awkwardly worded. I am passing in an empty "response" object, which contains the question information here,
// and then rendering the questions those responses relate to. Each evaluation has empty responses that are
// created when an evaluation is created... and then we then update that response with the selected answer. I will clear up this
// wording later.
export default {
  name: 'Question',
  props: {
    response: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      answer: null,
    }
  },
  computed: {
    isNA() {
      return (
        this.response.questionRef.questionType === 'OPEN_TEXT' &&
        this.response.response &&
        this.response.response.toUpperCase().trim() === 'N/A'
      )
    },
  },
  methods: {
    toggleNA() {
      if (this.isNA) {
        this.response.response = ''
      } else {
        this.response.response = 'N/A'
      }
      this.signalChange()
    },
    signalChange() {
      this.$emit('change')
    },
  },
}
</script>

<style lang="scss">
textarea.skipped {
  background-color: #ddd !important;
}
</style>
